import { Center, Container, Image, SimpleGrid, Text, Title } from '@mantine/core';
import image from '../../assets/images/maintenance.jpg';
import classes from './index.module.css';
import { Link } from 'react-router-dom';
import { Translate } from 'react-auto-translate';

/*
  * Maintenance Mode Page
*/
function PageOnMaintenance() {
  return (
		<Container className={classes.root}>
			<Center w="100%" h="100dvh">
				<SimpleGrid
					spacing={{ base: 40, sm: 80 }}
					cols={{ base: 1, sm: 2 }}
					className={classes.grid_center}
				>
					<Image src={image} className={classes.mobileImage} />
					<div>
						<Title className={classes.title}>
							<Translate>
								We&rsquo;ll be back soon!
							</Translate>
						</Title>
						<Text c="dimmed" size="lg">
							<Translate>
								Sorry for the inconvenience but we&rsquo;re
								performing some maintenance at the moment. If you
								need to you can always{' '}
							</Translate>
							<Link
								underline="hover"
								href="mailto:info@qs2500.com"
							>
								<Translate>
									contact us
								</Translate>
							</Link>
							<Translate>
								, otherwise we&rsquo;ll be back online shortly!
							</Translate>
						</Text>
						<Text c="dimmed" size="lg">
							&mdash; MaximumAccountability Team
						</Text>
					</div>
					<Image src={image} className={classes.desktopImage} />
				</SimpleGrid>
			</Center>
		</Container>
  );
}

export default PageOnMaintenance
